import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, boolean>;

export const BooleanCell: React.FC<Props> = ({ formattedValue }) => {
  return <span>{formattedValue}</span>;
};
